export default {"theme":{"themes":{"light":{"primary":"#7AAE51","primary_lighten":"#aacd81","line":"#06C755"}}}}
